import { render, staticRenderFns } from "./AssessmentGlobalSingleTaskModalFooter.vue?vue&type=template&id=09bd339c&"
import script from "./AssessmentGlobalSingleTaskModalFooter.vue?vue&type=script&lang=js&"
export * from "./AssessmentGlobalSingleTaskModalFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports